import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useCart } from "../CartContext";
import Header from "../components/Header";
import { motion } from "framer-motion";

const ProductDetails = ({ products }) => {
    const { id, variant } = useParams();
    const { addToCart, cart } = useCart();
    const [selectedVariant, setSelectedVariant] = useState(null);
    const [product, setProduct] = useState(null);
    const [buttonText, setButtonText] = useState("Add to Cart");
    const navigate = useNavigate();

    useEffect(() => {
        if (products.length > 0) {
            const selectedProduct = products.find((p) => p.id === parseInt(id));
            if (selectedProduct) {
                setProduct(selectedProduct);
                const variantData = selectedProduct.variants.find(
                    (v) =>
                        (v.color && v.color.toLowerCase() === variant.toLowerCase()) ||
                        (v.model && v.model.toLowerCase() === variant.toLowerCase())
                );
                setSelectedVariant(variantData);
            }
        }
    }, [products, id, variant]);

    if (!selectedVariant) {
        return <h1 className="text-center text-rose-300 text-2xl mt-20">Variant Not Found</h1>;
    }

    const cartItem = cart.find(
        (item) =>
            item.id === product.id &&
            item.variant.color === selectedVariant.color &&
            item.variant.model === selectedVariant.model
    );

    const handleAddToCart = () => {
        addToCart({
            id: product.id,
            variant: selectedVariant,
        });
        setButtonText("Added to Cart");

        setTimeout(() => {
            setButtonText("Add to Cart"); // Reset button text after the timeout
            navigate("/products");
        }, 1200);
    };

    return (
        <div className="min-h-screen flex flex-col bg-black text-rose-300">
            {/* Header Section */}
            <Header />

            {/* Product Details Section */}
            <div className="flex-grow pt-24 pb-12 flex items-center justify-center px-4">
                <motion.div
                    className="max-w-6xl w-full border border-rose-300 rounded-lg shadow-lg bg-black p-6 flex flex-col md:flex-row items-center md:items-start gap-8"
                    initial={{ opacity: 0, scale: 0.9 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.5 }}
                >
                    {/* Product Image */}
                    <motion.img
                        src={selectedVariant.image_url}
                        alt={selectedVariant.model || selectedVariant.color}
                        className="w-full md:w-1/2 h-72 object-cover rounded-md mb-4 md:mb-0 shadow-md"
                        whileHover={{ scale: 1.02 }}
                    />

                    {/* Product Info */}
                    <div className="w-full md:w-1/2 text-center md:text-left">
                        <h2
                            className="text-3xl md:text-4xl font-extrabold mb-4"
                            style={{ fontFamily: "'Poppins', sans-serif" }}
                        >
                            {selectedVariant.model || selectedVariant.color}
                        </h2>
                        <p className="text-xl md:text-2xl text-rose-200 mb-4">${selectedVariant.price.toFixed(2)}</p>
                        <p className="text-lg text-rose-100 mb-6">{selectedVariant.description}</p>

                        {/* Add to Cart Button */}
                        <div className="flex justify-center md:justify-start">
                            <motion.button
                                onClick={handleAddToCart}
                                className="bg-rose-600 text-white px-8 py-3 rounded-lg hover:bg-rose-700 transition transform hover:scale-105"
                                whileTap={{ scale: 0.95 }}
                            >
                                {buttonText}
                            </motion.button>
                        </div>
                    </div>
                </motion.div>
            </div>
        </div>
    );
};

export default ProductDetails;
